import { PayloadAction } from '@reduxjs/toolkit';
import { Attribute, DesignState } from 'src/store/design/types';

const setDesignSelectedProductAttributesReducer = (state: DesignState, action: PayloadAction<{ [typeName: string]: Attribute }>) => {
  state.selectedProductAttributes = action.payload;
};

export default setDesignSelectedProductAttributesReducer;
